import config from 'configs';

const { dbetApiUrl } = config;

class DbetSingleton {
  static instance = {};

  static #hasInstance = false;

  static getInstance() {
    return DbetSingleton.instance;
  }

  static async init() {
    if (DbetSingleton.#hasInstance) return Promise.resolve(DbetSingleton.getInstance());

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `${dbetApiUrl}/dbetWebLib.js`;

      script.onload = function () {
        const dbet = new window.DbetWebLib(process.env.REACT_APP_PARTNER_ID);

        DbetSingleton.#hasInstance = true;
        DbetSingleton.instance = Object.assign(DbetSingleton.instance, dbet);

        resolve(dbet);
      };

      script.onerror = function () {
        reject(new Error('Dbet could not be loaded'));
      };

      document.head.appendChild(script);
    });
  }

  constructor(instance) {
    if (instance && !DbetSingleton.#hasInstance) {
      DbetSingleton.#hasInstance = true;
      DbetSingleton.instance = Object.assign(DbetSingleton.instance, instance);
    }

    return DbetSingleton.instance;
  }
}

export default DbetSingleton;
